var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9231 0.600416L1.55851 12.477C1.55851 12.477 0.11926 12.9669 0.231591 13.8697C0.343923 14.7725 1.51638 15.1854 1.51638 15.1854L9.15492 17.7469L27.493 6.13628C27.493 6.13628 28.5532 5.49242 28.511 6.13628C28.511 6.13628 28.7006 6.24826 28.1319 6.78015C27.5632 7.30505 13.7254 19.7135 13.7254 19.7135L12.7285 28.1888C13.1497 28.3707 13.5358 28.0768 13.5358 28.0768L18.4714 23.5907L26.1661 29.4695C28.2442 30.3723 29.0025 28.4897 29.0025 28.4897L34.4084 1.30727C34.4225 -0.49136 31.9231 0.600416 31.9231 0.600416Z",
    fill: "#F1EACF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram-logo.707f4a24.svg";
export { ForwardRef as ReactComponent };